// extracted by mini-css-extract-plugin
export default {"wrapper":"Countdown_wrapper__Kr9hg","finished":"Countdown_finished__zhUD8"};